import { CREATOR_FIELDS } from '../user/fragment';

export const REPORTS_STAT = `
  query reportsStat {
    reportsStat {
      reportCreated
      reportCreatedByDay
      reportCreatedByWeek
    }
  }
`;

export const MODERATION_REASONS = `
  query moderationReasons($language: String) {
    moderationReasons(language: $language) {
      code
      title
      description
    }
  }
`;

// Fields of a report in the admin (list and drawer).
const REPORT_FIELDS = `
        id
        createdAt
        reason
        reporterId
        reporter {
          id
          avatar
          username
        }
        status
        userId
        user {
          ${CREATOR_FIELDS}
        }
        commentId
        comment {
          id
          message
        }
        videoId
        video {
          id
          codeshare
          description
          gameName
          mode
          path
          short
          thumbnail
          thumbnailInPng
          user {
            id
            username
          }
        }
        thumbnail
        type
        moderationReason
        isNotified
        resolvedAt
`;

export const REPORTS_ADMIN_PAGINATION = `
  query reportsPagination($input: ReportPaginationInput) {
    reportsPagination(input: $input) {
      docs {
        ${REPORT_FIELDS}
      }
      totalDocs
      offset
      limit
      hasNextPage
    }
  }
`;

// Admin: one report, opened from the notification of its removal.
export const REPORT_BY_ID = `
  query reportById($id: ID!) {
    reportById(id: $id) {
      ${REPORT_FIELDS}
    }
  }
`;

// Removal reason of a video, shown to its creator (title and description in his language).
export const MODERATION_DECISION = `
  query moderationDecision($reportId: ID!, $language: String) {
    moderationDecision(reportId: $reportId, language: $language) {
      reportId
      title
      description
      resolvedAt
      thumbnail
    }
  }
`;

// Number of open reports: the counter of "Signalements" in the menu of the admin.
export const OPEN_REPORTS_COUNT = `
  query openReportsCount {
    openReportsCount
  }
`;
